<template>
  <b-card-actions>
    <b-card-body>
      <div
        class="d-flex justify-content-start row no-gutters"
        v-if="user.full_name"
      >
        <span
          class="b-avatar badge-light-danger rounded"
          style="width: 104px; height: 104px"
          ><span class="b-avatar-img"
            ><img :src="user.profile_image_path" alt="avatar" /></span
          ><!----></span
        >
        <div class="d-flex flex-column ml-1 col">
          <div class="mb-9">
            <h5 class="mb-1">
              <span
                class="font-weight-bolder"
                v-if="user.account_type == 'student'"
                >اسم الطالب :</span
              >
              <span
                class="font-weight-bolder"
                v-if="user.account_type == 'teacher'"
                >اسم المعلم :</span
              >
              <span
                class="font-weight-bolder"
                v-if="user.account_type == 'admin'"
                >اسم المشرف :</span
              >
              {{ user.full_name }}
            </h5>

            <hr />
            <h5 class="mb-1">
              <span class="font-weight-bolder">البريد الإلكتروني :</span>
              {{ user.email }}
            </h5>

            <hr />
            <h5 class="mb-1">
              <span class="font-weight-bolder">فصل :</span>
              <span class="text-success">
                {{ room.name }}
              </span>
            </h5>
          </div>
        </div>
      </div>
      <b-spinner v-else type="grow" label="Loading..."  class="loading" />

      <b-row>
        <b-col lg="6">
          <b-btn :to="{ name: 'profile' }" block variant="relief-info">
            <feather-icon size="16" icon="UserIcon" class="mr-50" />

            عرض ملفي الشخصي
          </b-btn>
        </b-col>
        <b-col lg="6">
          <b-btn @click="logout" block variant="relief-danger">
            <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
            تسجيل الخروج
          </b-btn>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card-actions>
</template>

<script>
import Auth from "@/Apis/Auth";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

// import { BCard, BButton, BAvatar, BRow, BCol } from "bootstrap-vue";

export default {
  components: {
    BCardActions,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      room: {},
    };
  },
  created() {
    let id = localStorage.getItem("eduProgram");
    let room = Auth.ROOM.find((a) => a.edu_program_id == id);
    if (room) this.room = room;
  },
  methods: {
    logout() {
      Auth.logOut();
    },
  },
};
</script>

<style></style>
